<template>
	<div class="main">
		<div class="material-main-content">
			<div class="material-main-content-left">
				<div class="material-list-dance">
					sadadas
				</div>
			</div>
			<div class="material-main-content-right"></div>
		</div>
	</div>
</template>
<script>
	export default{
		data(){
			return{

			}
		}
	};
</script>
<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/material/material.vue